import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Alt6Nav from './Alt6Nav';
import Alt6Footer from './Alt6Footer';
import '../alt6.css';

export default function Alt6Layout({ title, children }) {
  const location = useLocation();
  const mainRef = useRef(null);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | Asha` : 'Asha | The AI-native OS for dental';
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  useEffect(() => {
    mainRef.current?.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="alt6-root">
      <a className="a6-skip-link" href="#alt6-main">
        Skip to content
      </a>
      <Alt6Nav />
      <main id="alt6-main" ref={mainRef} tabIndex={-1}>
        {children}
      </main>
      <Alt6Footer />
    </div>
  );
}
